import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import SEOHead from '@/components/base/SEOHead';
import { articles, getHotArticles, getTrendingArticles, getLatestArticles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';


export default function Home() {
  const hotArticles = getHotArticles();
  const trendingArticles = getTrendingArticles();
  const latestArticles = getLatestArticles(8);
  const featuredArticle = articles[0];

  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '51每日大赛官网 - 今日吃瓜黑料与精选内容',
    description: '51每日大赛官网今日吃瓜黑料与精选内容，网红明星塌房现场猛料实时追踪，每日更新吃瓜。',
    url: 'https://www.51meiridasai.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '51每日大赛',
      url: 'https://www.51meiridasai.com/',
    },
  };

  return (
    <>
      <SEOHead
        title="51每日大赛官网 - 51每日大赛今日吃瓜黑料与51每日大赛精选内容 | 网红明星塌房现场猛料实时追踪每日更新吃瓜"
        description="51每日大赛官网今日吃瓜黑料与精选内容，网红明星塌房现场猛料实时追踪，每日更新吃瓜，汇聚每日大赛吃瓜爆料与黑料网。实时追踪网红主播、明星艺人塌房事件，提供最新最全的娱乐八卦资讯。"
        keywords="51每日大赛官网,51每日大赛今日吃瓜,51每日大赛黑料,51每日大赛精选内容,网红明星塌房,每日更新吃瓜,实时追踪"
        canonicalUrl="https://www.51meiridasai.com/"
        schema={homeSchema}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dramatic%20abstract%20composition%20with%20explosive%20warm%20crimson%20and%20deep%20charcoal%20waves%2C%20dynamic%20energy%20burst%2C%20modern%20artistic%20style%2C%20bold%20contrast%2C%20dark%20atmosphere%20with%20bright%20warm%20highlights%2C%20cinematic%20composition%2C%20no%20text%20no%20people%2C%20flowing%20organic%20shapes&width=1800&height=800&seq=hero-bg-main-001&orientation=landscape"
            alt="51每日大赛 - 今日吃瓜热榜"
            title="51每日大赛 - 网红明星塌房现场猛料实时追踪"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-16">
                <div className="flex-1 animate-fade-in-up">
                  <h1 className="text-white text-4xl md:text-6xl lg:text-7xl font-black leading-tight tracking-tight">
                    <span className="block">网红明星</span>
                    <span className="block text-primary-400">塌房现场</span>
                  </h1>
                  <p className="text-white/70 text-sm md:text-base mt-4 md:mt-6 max-w-md leading-relaxed">
                    实时追踪网红主播与明星艺人的塌房事件，全网最新最热的吃瓜爆料，每日更新让你不错过任何一条猛料。
                  </p>
                  <Link
                    to="/category/meiri-chigua"
                    className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    查看今日热榜
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>

                <div className="flex-1 w-full animate-fade-in-up animation-delay-200">
                  <div className="relative rounded-2xl overflow-hidden h-[220px] md:h-[320px]">
                    <img
                      src={featuredArticle.imageUrl}
                      alt={featuredArticle.title}
                      title={featuredArticle.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                      <span className="inline-block px-2.5 py-1 bg-accent-500 text-background-50 text-xs rounded-md mb-2 whitespace-nowrap">
                        {featuredArticle.category}
                      </span>
                      <h2 className="text-white text-lg md:text-xl font-bold leading-snug">
                        {featuredArticle.title}
                      </h2>
                      <Link
                        to={`/article/${featuredArticle.id}`}
                        className="inline-flex items-center gap-1 text-white/80 text-sm mt-2 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        阅读全文 <i className="ri-arrow-right-line text-xs"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="w-full bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 py-5 overflow-x-auto flex-nowrap">
              <Link
                to="/"
                className="px-4 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer"
              >
                全部
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-4 py-2 bg-background-100 text-foreground-600 text-sm font-medium rounded-full hover:bg-primary-100 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Articles Grid */}
        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-black text-foreground-900">
                  今日吃瓜热榜
                </h2>
                <p className="text-foreground-500 text-sm mt-1">实时更新 · 全网追踪</p>
              </div>
              <Link
                to="/category/meiri-chigua"
                className="hidden sm:flex items-center gap-1 text-primary-500 text-sm font-medium hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看更多 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {hotArticles.slice(0, 4).map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>

            {hotArticles.length === 0 && (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {articles.slice(0, 4).map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            )}
          </div>
        </section>

        {/* Featured Content - Three Column */}
        <section className="w-full py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-8 gap-3">
              <div>
                <h2 className="text-2xl md:text-3xl font-black text-foreground-900">
                  <span className="text-primary-500">51每日大赛</span> 精选内容
                </h2>
                <p className="text-foreground-500 text-sm mt-1">编辑精选，深度吃瓜</p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
              <div className="lg:col-span-2">
                <ArticleCard article={articles[6]} variant="large" />
              </div>
              <div className="flex flex-col gap-5">
                <ArticleCard article={articles[9]} />
                <ArticleCard article={articles[11]} />
              </div>
            </div>
          </div>
        </section>

        {/* Trending Articles */}
        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-black text-foreground-900">
                  实时追踪
                </h2>
                <p className="text-foreground-500 text-sm mt-1">热点事件持续跟进</p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {trendingArticles.slice(0, 4).map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* User Comments / Testimonials */}
        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="relative rounded-2xl overflow-hidden" style={{ backgroundColor: '#1a1a1a' }}>
              <div className="absolute top-0 left-0 w-32 h-32 md:w-40 md:h-40 opacity-10">
                <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                  <path fill="none" stroke="#fff" strokeWidth="1.5" d="M20,100 Q60,20 100,60 T180,40" opacity="0.6"/>
                  <path fill="none" stroke="#fff" strokeWidth="1.5" d="M10,140 Q50,60 90,100 T190,80" opacity="0.4"/>
                  <path fill="none" stroke="#fff" strokeWidth="1" d="M30,80 Q70,10 110,50 T170,30" opacity="0.5"/>
                </svg>
              </div>

              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/3 relative">
                  <div className="h-64 lg:h-full overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Dramatic%20portrait%20style%20silhouette%20with%20warm%20golden%20and%20deep%20red%20abstract%20background%2C%20mysterious%20artistic%20lighting%2C%20editorial%20fashion%20photography%2C%20bold%20contrast%2C%20striking%20visual%20impact%2C%20no%20recognizable%20face%20features&width=600&height=800&seq=testimonial-avatar-01&orientation=portrait"
                      alt="51每日大赛用户热评"
                      title="吃瓜群众热评精选"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                <div className="lg:w-2/3 p-8 md:p-12 flex flex-col justify-center">
                  <span className="text-6xl md:text-8xl font-serif text-primary-400/30 leading-none select-none">&ldquo;</span>
                  <p className="text-white/90 text-lg md:text-xl leading-relaxed -mt-6">
                    每天第一件事就是打开51每日大赛，看看今天又有什么新瓜。从网红翻车到明星塌房，这里真的是吃瓜第一线，比微博还快！
                  </p>
                  <div className="mt-6">
                    <p className="text-white/60 text-sm">—— 资深吃瓜群众 · 热评#1286</p>
                  </div>
                  <Link
                    to="/category/meiri-chigua"
                    className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 bg-accent-500/20 border border-accent-400/30 text-accent-300 rounded-full text-sm font-medium hover:bg-accent-500/30 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    查看更多神评
                    <i className="ri-arrow-right-line text-xs"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Latest Articles */}
        <section className="w-full py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-2xl md:text-3xl font-black text-foreground-900">
                  最新爆料
                </h2>
                <p className="text-foreground-500 text-sm mt-1">每日更新，吃瓜不停</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} article={article} variant="compact" />
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="relative w-full h-[380px] md:h-[450px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dynamic%20composition%20with%20flowing%20crimson%20and%20charcoal%20waves%2C%20energetic%20artistic%20style%2C%20bold%20dramatic%20contrast%2C%20modern%20abstract%20expressionism%2C%20warm%20fiery%20tones%20blending%20with%20deep%20dark%20shadows%2C%20cinematic%20atmosphere&width=1800&height=600&seq=cta-bg-subscribe-001&orientation=landscape"
            alt="51每日大赛 - 订阅爆料"
            title="立即订阅51每日大赛最新爆料"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/30"></div>

          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <h2 className="text-white text-4xl md:text-6xl font-black leading-tight mb-6 animate-fade-in-up">
                  get latest gossip
                </h2>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-900 rounded-full font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  立即订阅爆料
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-foreground-900 text-background-50">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </Link>
                <p className="text-white/60 text-sm mt-12 max-w-xs leading-relaxed">
                  覆盖网红圈、娱乐圈、电竞圈等多领域，每日更新最新吃瓜资讯
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-900 text-center mb-10">
              关于51每日大赛
            </h2>
            <div className="space-y-4">
              <div className="bg-background-100 rounded-xl p-5 md:p-6">
                <h4 className="text-foreground-900 font-bold text-base mb-2">
                  <a href="#faq-1" className="hover:text-primary-500 transition-colors">51每日大赛是什么网站？</a>
                </h4>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  51每日大赛是一个专注于网红明星塌房事件和娱乐八卦资讯的聚合平台，致力于为吃瓜群众提供最新、最快、最全的爆料内容。我们每日更新，覆盖网红圈、娱乐圈、电竞圈等多个领域。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 md:p-6">
                <h4 className="text-foreground-900 font-bold text-base mb-2">
                  <a href="#faq-2" className="hover:text-primary-500 transition-colors">51每日大赛的内容来源可靠吗？</a>
                </h4>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  我们的内容团队通过多渠道交叉验证，确保每一条爆料的真实性。对于尚未完全证实的信息，我们会在文章中明确标注"待确认"，让读者自行判断。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 md:p-6">
                <h4 className="text-foreground-900 font-bold text-base mb-2">
                  <a href="#faq-3" className="hover:text-primary-500 transition-colors">如何向51每日大赛投稿爆料？</a>
                </h4>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  您可以通过我们的爆料投稿页面提交线索，或发送邮件至 tips@51meiridasai.com。我们承诺对爆料人信息严格保密，并会在核实后第一时间发布。
                </p>
              </div>
              <div className="bg-background-100 rounded-xl p-5 md:p-6">
                <h4 className="text-foreground-900 font-bold text-base mb-2">
                  <a href="#faq-4" className="hover:text-primary-500 transition-colors">51每日大赛更新频率是怎样的？</a>
                </h4>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  我们保持每日多次更新的节奏，重大事件发生后15分钟内即可上线报道。关注我们的首页"今日吃瓜热榜"区域，获取实时更新的最新内容。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}